import { AppColors } from "@/styles/colors";
import { Badge, Box, Image, Text } from "@chakra-ui/react";

import UnionCoop from "@/assets/union-coop-secondary.svg";

export const LogoAndBadge = () => (
  <Box display="flex" flexDirection="column" zIndex={2}>
    <Image src={UnionCoop} alt="Unión Cooperativa" mb={4} />

    <Badge variant="solid" bgColor={AppColors.GREEN_PRIMARY}>
      <Text
        fontWeight={700}
        fontSize={{ xl: "16px", md: "12px" }}
        paddingY={1}
        paddingX={2}
      >
        BACK OFFICE
      </Text>
    </Badge>
  </Box>
);
